// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import copyToClipboard from "@store/Framework/Common/Utilities/copyToClipboard";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";
import CopyLine from "@store/Library/Components/Toolkit/Icons/Copy/CopyLine";
import { css } from "styled-components";

export interface CopyButtonPresentationProps extends ExpandStyles<CopyButtonStyles> {}

export interface CopyButtonProps extends CopyButtonPresentationProps {
    text: string;
}

export interface CopyButtonStyles {
    button?: ClickablePresentationProps;
    icon?: IconPresentationProps;
}

export const copyButtonStyles: CopyButtonStyles = {
    button: {
        css: css`
            display: inline-flex;
        `,
    },
    icon: {
        src: CopyLine,
        size: 20,
        color: "text.light",
    },
};

const CopyButton: FC<CopyButtonProps> = ({ text, extendedStyles, overridedStyles }) => {
    const toaster = useToaster();
    const styles = useExpandProps(copyButtonStyles, extendedStyles, overridedStyles);

    const handleClick = () => {
        copyToClipboard(text).then(isCopied => {
            toaster.addToast({
                body: translate(isCopied ? "Copied to clipboard" : "Unable to copy to clipboard"),
                messageType: isCopied ? "success" : "danger",
                timeoutLength: 3000,
            });
        });
    };

    return (
        <Clickable {...styles.button} onClick={handleClick} title={translate("Copy")}>
            <IconMemo {...styles.icon} title={translate("Copy")} />
        </Clickable>
    );
};

export default CopyButton;
